import { Controller } from "@hotwired/stimulus"

// Anchors a native [popover] menu to its trigger. Opening, closing and
// light dismiss are the Popover API's job (via popovertarget on the
// button); this controller only computes the position, until CSS anchor
// positioning is available everywhere. placement "top" opens above the
// trigger aligned to its left edge (sidebar user menu); "bottom" opens
// below, centered on the trigger (top bar menus, UIMenu-style); "end"
// opens beside its trigger and flips when the preferred side has no room
// (accessory submenus).
export default class extends Controller {
  static targets = ["button", "menu"]
  static values = {
    placement: { type: String, default: "top" },
    open: { type: Boolean, default: false }
  }

  connect() {
    if (this.openValue) this.menuTarget.showPopover?.()
  }

  menuTargetConnected(menu) {
    menu.addEventListener("toggle", this.reposition)
  }

  // For menu items that navigate without leaving the page (a turbo-frame
  // link, a button_to): light dismiss only covers clicks outside
  close() {
    this.menuTarget.hidePopover?.()
  }

  menuTargetDisconnected(menu) {
    menu.removeEventListener("toggle", this.reposition)
  }

  reposition = (event) => {
    if (event.newState !== "open") return

    const anchor = this.buttonTarget.getBoundingClientRect()
    const menu = this.menuTarget
    menu.style.minWidth = `${Math.max(anchor.width, 224)}px`

    const { width, height } = menu.getBoundingClientRect()
    const margin = 8
    const placement = this.placementValue
    const below = placement === "bottom"
    const beside = placement === "end"
    let left
    let top

    if (beside) {
      const rtl = getComputedStyle(this.element).direction === "rtl"
      const preferredLeft = rtl ? anchor.left - width - margin : anchor.right + margin
      const alternateLeft = rtl ? anchor.right + margin : anchor.left - width - margin
      const preferredFits = preferredLeft >= margin && preferredLeft + width <= window.innerWidth - margin

      left = preferredFits ? preferredLeft : alternateLeft
      top = anchor.top + anchor.height / 2 - height / 2
    } else {
      left = below ? anchor.left + anchor.width / 2 - width / 2 : anchor.left
      top = below ? anchor.bottom + margin : anchor.top - height - margin
    }

    menu.style.left = `${Math.min(Math.max(margin, left), window.innerWidth - width - margin)}px`
    menu.style.top = `${Math.min(Math.max(margin, top), window.innerHeight - height - margin)}px`
  }
}
